import { render, staticRenderFns } from "./CurrentTag_v2.vue?vue&type=template&id=0a66f188&"
import script from "./CurrentTag_v2.vue?vue&type=script&lang=js&"
export * from "./CurrentTag_v2.vue?vue&type=script&lang=js&"
import style0 from "./CurrentTag_v2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports